import React from 'react';
import './styles/style.css';

const PrimaryButton = ({
  icon,
  text,
  onClick,
  disabled = false,
  type = 'button',
  size = 'M',
  className = '',
  iconPlacement = 'left',
  ...props
}) => {
  const sizeClass = size === 'S' ? 'primaryButton--sm' : size === 'L' ? 'primaryButton--lg' : '';

  return (
    <button
      type={type}
      className={`primaryButton ${sizeClass} ${disabled ? 'disabled' : ''} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {icon && iconPlacement === 'left' && <div className="primaryButton-icon notranslate" translate="no">{icon}</div>}
      <div className="primaryButton-text">{text}</div>
      {icon && iconPlacement === 'right' && <div className="primaryButton-icon notranslate" translate="no">{icon}</div>}
    </button>
  );
};

export default PrimaryButton;